/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_ReadyInputs */

const cs_property_legal_ready = /** @type {(inputs: Property_Legal_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotovo`)
};

const en_property_legal_ready = /** @type {(inputs: Property_Legal_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Property_Legal_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_ready = /** @type {((inputs?: Property_Legal_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_ready(inputs)
	return cs_property_legal_ready(inputs)
});